import { fetchQuarterly } from '@features/quarterlyInput/redux/api';
import LocalStorage from './localStorage';
import { calc } from 'antd/es/theme/internal';
import LeaderShipDashboard from '@features/dashboard/components/leaderShipDashboard';

export const apiUrl = process.env.REACT_APP_API_URL;

const encodeQueryData = (data = null) => {
  if (data) {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return '?' + ret.join('&');
  }
  return '';
};

const getLocalToken = () => {
  const user = LocalStorage.getItem('bbs_user');
  const authToken = user?.accessToken;
  if (authToken !== null && authToken !== '') {
    return `${authToken}`;
  } else {
    return '';
  }
};
const apiClient = {
  Urls: {
    apiUrl,
    projectList: `${apiUrl}/projects/projectsList`,
    locations: `${apiUrl}/projects/locations`,
    bbsCreate: `${apiUrl}/bbs/create`,
    bbsList: `${apiUrl}/bbs/bbs-list`,
    projectCount: `${apiUrl}/dashboard/analytics`,
    bbsOptimise: `${apiUrl}/bbs/optimise`,
    signin: `${apiUrl}/auth/signin`,
    fetch: `${apiUrl}/reqApp/fetch`,
    newProject: `${apiUrl}/reqApp/new`,
    approverDashboard: `${apiUrl}/reqApp/user-requests`,
    viewProject: `${apiUrl}/reqApp/view/project`,
    managerDashboard: `${apiUrl}/manager/requests`,
    managerApproveProject: `${apiUrl}/manager/approve/project`,
    managerApproveUser: `${apiUrl}/manager/approve/user`,
    fetchApproveReject: `${apiUrl}/reqApp`,
    newBBS: `${apiUrl}/reqApp/approved`,
    editProjectUser: `${apiUrl}/reqApp/request`,
    editProject: `${apiUrl}/reqApp/editProject`,
    BBSView: `${apiUrl}/reqApp/view/bbs`,
    projectCountDashboard: `${apiUrl}/dashboard/project`,
    managerProjectCountDashboard: `${apiUrl}/dashboard/project-manager`,
    optimizationCountDashboard: `${apiUrl}/dashboard/optimization`,
    managerOptimizationCountDashboard: `${apiUrl}/dashboard/optimization-manager`,
    bbsAlgorithm: `${apiUrl}/opt/process-csv`,
    pdf_download: `${apiUrl}/pdf/download`,
    fetch: `${apiUrl}/reqApp/fetch`,
    newProject: `${apiUrl}/reqApp/new`,
    approverDashboard: `${apiUrl}/reqApp/user-requests`,
    viewProject: `${apiUrl}/reqApp/view/project`,
    managerDashboard: `${apiUrl}/manager/requests`,
    managerApproveProject: `${apiUrl}/manager/approve/project`,
    managerApproveUser: `${apiUrl}/manager/approve/user`,
    fetchApproveReject: `${apiUrl}/reqApp`,
    newBBS: `${apiUrl}/reqApp/approved`,
    editProjectUser: `${apiUrl}/reqApp/request`,
    editProject: `${apiUrl}/reqApp/editProject`,
    BBSView: `${apiUrl}/reqApp/view/bbs`,
    projectCountDashboard: `${apiUrl}/dashboard/project`,
    managerProjectCountDashboard: `${apiUrl}/dashboard/project-manager`,
    optimizationCountDashboard: `${apiUrl}/dashboard/optimization`,
    managerOptimizationCountDashboard: `${apiUrl}/dashboard/optimization-manager`,
    bbsAlgorithm: `${apiUrl}/opt/process-csv`,
    pdf_download: `${apiUrl}/pdf/download`,
    bbsViewFiles: `${apiUrl}/bbs/consolidated-data`,
    bbsInactivate: `${apiUrl}/bbs/inactivate`,
    getBbs: `${apiUrl}/bbs/get`,
    projectList: `${apiUrl}/quarterly/project-list`,
    fetchQuarterly: `${apiUrl}/quarterly/fetch`,
    quarterlyView: `${apiUrl}/quarterly/view`,
    calculateQuarterly: `${apiUrl}/quarterly/calculate`,
    submitQuarterly: `${apiUrl}/quarterly/new`,
    leaderShipDashboard: `${apiUrl}/leadership/analytics`,
    leaderShipDashboard_manager: `${apiUrl}/leadership/manager-analytics`,
    leaderShipTableData: `${apiUrl}/leadership/data`,
    leaderShipToolAnalytics: `${apiUrl}/leadership/tool/analytics`,
    leaderShipToolData: `${apiUrl}/leadership/tool/data`,
    leaderShipManagerTableData: `${apiUrl}/leadership/manager-data`,
    projectListManager: `${apiUrl}/quarterly/manager-project-list`,
    finalBBSOutput: `${apiUrl}/bbs/output-file`,
    estimate: `${apiUrl}/quarterly/estimate`,
    financialYear: `${apiUrl}/quarterly/financial-years`,
    quarter: `${apiUrl}/quarterly/financial-quarters`,
    quarterManager: `${apiUrl}/quarterly/manager-financial-quarters`,
    inputFiles: `${apiUrl}/bbs/input-files`,
    projectDetails: `${apiUrl}/leadership/project/details`,
    leadershipFilterData: `${apiUrl}/leadership/filtered-data`,
    financialYears: `${apiUrl}/quarterly/financial-years`,
    finalSummary: `${apiUrl}/bbs/final-summary`,
    leadershipProjectList: `${apiUrl}/bbs/project-list`,
    sbgList: `${apiUrl}/bbs/sbg-list`,
    sbuList: `${apiUrl}/bbs/sbu-list`,
    buList: `${apiUrl}/bbs/bu-list`,
    quarterList: `${apiUrl}/bbs/quarter-list`,
    leadershipProjectList_TA: `${apiUrl}/leadership/project-list`,
    sbgList_TA: `${apiUrl}/leadership/sbg-list`,
    sbuList_TA: `${apiUrl}/leadership/sbu-list`,
    buList_TA: `${apiUrl}/leadership/bu-list`,
    leadershipProjectListWithoutQuarterly: `${apiUrl}/bbs/project-list-no-quarterly`,
    leadershipProjectListManagerDashboard: `${apiUrl}/leadership/manager/project-codes-quarterly`,
    leadershipProjectListWithoutQuarterlyManagerDashboard: `${apiUrl}/leadership/manager/project-codes-no-quarterly`,
  },
  make: function (url, method, params, auth, type) {
    let headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    let authHeaders = {
      Authorization: getLocalToken(),
    };

    if (auth) {
      headers = {
        ...headers,
        ...authHeaders,
      };
    }

    if (method == 'GET') {
      let queryParams = '';
      if (Object.keys(params || {}).length) {
        queryParams = encodeQueryData(params);
      }
      return fetch(url + queryParams, {
        method,
        headers,
      })
        .then((response) => response.json())
        .catch((e) => e);
    } else {
      return fetch(url, {
        method,
        headers: type === 'file' ? authHeaders : headers,
        body: type === 'file' ? params : JSON.stringify(params),
      })
        .then((response) => response.json())
        .catch((e) => e);
    }
  },

  get: function (url, params, auth) {
    return apiClient.make(url, 'GET', params, auth);
  },

  post: function (url, params, auth, type) {
    return apiClient.make(url, 'POST', params, auth, type);
  },

  put: function (url, params, auth) {
    return apiClient.make(url, 'PUT', params, auth);
  },

  patch: function (url, params, auth) {
    return apiClient.make(url, 'PATCH', params, auth);
  },

  delete: function (url, params, auth) {
    return apiClient.make(url, 'DELETE', params, auth);
  },
};

export default apiClient;
